import {
    GetFileList,
    DeleteFile,
    DeleteFolder,
    CreateItem,
    EditFile,
    RegiterDownload,
} from '@src/services/file-manager'
import { getSavedState } from '@src/utils/localStorage'

export const state = {
    fileList: [],
    userIp: '',
}

export const getters = {
    // totalList(state) {
    //     return state.fielList.data ? state.fielList.data.totalItemCount : 0
    // },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.fileList = newList
    },
    NEXT_PAGE_LIST(state, newList) {
        newList.forEach((file) => {
            state.fielList.data.items.push(file)
        })
    },
    DELETE_FILE(state, file) {
        state.fileList.data = state.fileList.data.filter(
            ({ label, extension }) => {
                return `${label}.${extension}` !== file.fileName
            }
        )
    },
    DELETE_FOLDER(state, folder) {
        state.fileList.data = state.fileList.data.filter(({ id }) => {
            return id !== folder.fileName
        })
    },
    SET_USER_IP(state, ip) {
        state.userIp = ip
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetFileList({
            locationPublicId,
            parameters,
        })
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
        return resp
    },
    async getUserIp({ commit }) {
        const request = await fetch('https://api.ipify.org?format=json')
        const json = await request.json()
        commit('SET_USER_IP', json.ip)
        return json.ip
    },
    async nextPage({ commit }, currentPage) {
        const resp = await GetFileList(currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
        return resp
    },
    async deleteFile({ _ }, file) {
        const resp = await DeleteFile(file)
        return resp
    },
    async deleteFolder({ commit }, folder) {
        const resp = await DeleteFolder(folder)
        if (resp.status === 200) {
            commit('DELETE_FOLDER', folder)
        }
        return resp
    },
    async createItem({ _ }, item) {
        const resp = await CreateItem(item)
        return resp
    },
    async putFile({ _ }, file) {
        const resp = await EditFile(file)
        return resp
    },
    async registerDownload({ _ }, file) {
        const resp = await RegiterDownload(file)
        return resp
    },
}